export default __webpack_public_path__ + "static/media/3.b7fe5b2a.webp";